module.exports = __webpack_public_path__ + "img/Pack Station (WMS Module)_Page_10.a256f6ac.jpg";